import { render } from "./GpuCounter.vue?vue&type=template&id=158abfa6&scoped=true&ts=true"
import script from "./GpuCounter.vue?vue&type=script&lang=ts"
export * from "./GpuCounter.vue?vue&type=script&lang=ts"

import "./GpuCounter.vue?vue&type=style&index=0&id=158abfa6&scoped=true&lang=css"
import "./GpuCounter.vue?vue&type=style&index=1&id=158abfa6&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158abfa6"]])

export default __exports__